export default {
    namespaced: true,
    state: {
        active: false,
        checked: false,
        text: '',
        cms: {
            show: false,
            link: '',
            name: ''
        },
        defaultChecked: false
    },
    mutations: {
        INIT (state, config) {
            state.active = config.enabled;
            state.text = config.text;
            state.showLink = config.cms.show;
            state.link = config.cms.link;
            state.linkName = config.cms.name;
            state.defaultChecked = config.status;
        },
        SET (state, checked) {
            state.checked = checked;
        },
    }
}